import React from "react";

type ClaimJurisdictionCardProps = {
	// 16px icon shown before the eyebrow text.
	eyebrowIcon: React.ReactNode;
	eyebrow: string;
	title: string;
	description: React.ReactNode;
	children?: React.ReactNode;
};

/**
 * White card of the claim screens: eyebrow, title, description and the content of the step.
 * The card fades in and moves up when it mounts. The screens give each step its own key, so
 * the animation runs again on every step.
 */
const ClaimJurisdictionCard = ({ eyebrowIcon, eyebrow, title, description, children }: ClaimJurisdictionCardProps) => {
	return (
		<div className="claim-jurisdiction-card">
			<div className="claim-jurisdiction-card-header">
				<div className="claim-jurisdiction-card-eyebrow">
					{eyebrowIcon}
					{eyebrow}
				</div>
				<h2 className="claim-jurisdiction-card-title">{title}</h2>
				<p className="claim-jurisdiction-card-description">{description}</p>
			</div>
			{children && <div className="claim-jurisdiction-card-content">{children}</div>}
		</div>
	);
};

export default ClaimJurisdictionCard;
